<template>

  <v-layout class="inner-pages" column>
    <Header :header-height="$auth.check() ? '70px': '120px'" />

    <scroll-data>
      <Program52 v-if="gameId === 52"/>
      <Program62 v-if="gameId === 62"/>
      <Program59 v-if="gameId === 59"/>
      <Program63 v-if="gameId === 65"/>
      <Program68 v-if="gameId === 68"/>
    </scroll-data>
  </v-layout>

</template>

<script>
  import ScrollData from '../../../ScrollData'
  import Header from '../../../layouts/Header'
  import Program59 from './Program59'
  import Program52 from './Program52'
  import Program62 from './Program62'
  import Program63 from './Program63'
  import Program68 from './Program68'
  export default {
    name: 'AnsiAccreditation',
    components: {Program59, Program52, Program62, Program63, Header, ScrollData, Program68},
    data: () => ({
      gameId: process.env.GAME_ID
    })
  }
</script>



// WEBPACK FOOTER //
// src/components/views/guest/AnsiAccreditation/index.vue